// شهرها
import React, { useState } from 'react';
import { ui } from '../../components/ListPage';
import CrudView from '../Tadarokat/CrudView';
import CityContractorPollution from '../Tadarokat/CityContractorPollution';
import { Field, TextInput, Lookup, makeApi, btnDisabled, toFa } from '../Tadarokat/basicShared';

const api = makeApi('/api/income');

const DIV_FILTERS = [
  { val: 1, label: 'شهرستان' }, { val: 2, label: 'شهر' }, { val: 3, label: 'دهیاری' },
  { val: 4, label: 'فاقد دهیاری' }, { val: 5, label: 'عشایر' }, { val: 0, label: 'سایر' },
];

const colsOf = meta => [
  { key: 'city_code', label: 'کد' }, { key: 'province_name', label: 'استان' },
  { key: 'division_title', label: 'تقسیمات کشوری' }, { key: 'above_city_name', label: 'شهر بالادستی' },
  { key: 'name', label: 'شهر' }, { key: 'population', label: 'جمعیت', num: true },
  { key: 'sub_population', label: 'جمعیت شهرهای تابعه', num: true },
  { key: 'pollution', label: 'درصد آلایندگی', num: true }, { key: 'remark', label: 'توضیح' },
  ...(meta.polluters || []).map((t, i) => ({ key: `p${i}`, label: t, num: true })),
];

const EMPTY = { name: '', city_code: '', province_id: 0, province_name: '', division: 0, above_city_id: 0,
  above_city_name: '', population: '0', remark: '' };

function Fields({ f, set, setMany, meta }) {
  const divs = meta.divisions || ['', 'شهرستان', 'شهر', 'دهیاری', 'فاقد دهیاری', 'عشایر'];
  return (
    <>
      <div style={ui.row}>
        <Lookup label="استان" api={api} text={f.province_name} endpoint="/cities/lookup/province/"
          onPick={r => setMany({ province_id: r.id, province_name: r.title || '' })} />
        <Field label="کد" width="110px"><TextInput value={f.city_code} onChange={v => set('city_code', v)} ltr /></Field>
      </div>
      <div style={ui.row}>
        <Field label="شهر"><TextInput value={f.name} onChange={v => set('name', v)} autoFocus /></Field>
        <Field label="تقسیمات کشوری" width="160px">
          <select value={f.division} onChange={e => set('division', Number(e.target.value))} style={ui.input}>
            {divs.map((d, i) => <option key={i} value={i}>{d}</option>)}
          </select>
        </Field>
      </div>
      <div style={ui.row}>
        <Lookup label="شهر بالادستی" api={api} text={f.above_city_name} endpoint="/cities/lookup/above/"
          onPick={r => setMany({ above_city_id: r.id, above_city_name: r.title || '' })} />
        <Field label="جمعیت" width="130px"><TextInput value={f.population} onChange={v => set('population', v)} ltr /></Field>
      </div>
      <div style={ui.row}>
        <Field label="توضیح"><TextInput value={f.remark} onChange={v => set('remark', v)} /></Field>
      </div>
    </>
  );
}

function Filters({ opts, setOpts, sel }) {
  const divs = opts.divs;
  const toggle = v => setOpts(o => ({ ...o, divs: o.divs.includes(v) ? o.divs.filter(x => x !== v) : [...o.divs, v] }));
  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', fontSize: '12px' }}>
      {DIV_FILTERS.map(d => (
        <label key={d.val} style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
          <input type="checkbox" checked={divs.includes(d.val)} onChange={() => toggle(d.val)} />{d.label}
        </label>
      ))}
      <label style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
        <input type="checkbox" checked={opts.pop_only} onChange={e => setOpts(o => ({ ...o, pop_only: e.target.checked }))} />
        فقط نمایش شهرهای دارای جمعیت
      </label>
      {sel && <span style={{ color: '#1a2f50', fontWeight: 700 }}>جمعیت کل: {toFa(Number(sel.sum_population || 0).toLocaleString('en-US'))}</span>}
    </div>
  );
}

export default function CityList({ user, onBack }) {
  const [pollution, setPollution] = useState(null);
  return (
    <CrudView user={user} onBack={onBack} api={api} form="FRMCITIES" title="شهرها" subtitle="سامانه ارجان" unit="شهر"
      buttons={['BTNCITYCONTRACTORPOLLUTION']} path="/cities" cols={colsOf} empty={EMPTY} modalWidth={640}
      initialOpts={{ divs: [0, 1, 2, 3, 4, 5], pop_only: false }}
      listQuery={o => `&divs=${(o.divs || []).join(',')}${o.pop_only ? '&pop_only=1' : ''}`}
      filters={Filters} renderFields={Fields} updateMethod="POST" deleteMethod="POST" changeBtn="BTNCHANGE"
      toForm={r => ({ ...EMPTY, ...r, city_code: String(r.city_code || ''), population: String(r.population || 0) })}
      reloadKey={pollution ? 1 : 0}
      extraButtons={({ sel, fb }) => fb.can('BTNCITYCONTRACTORPOLLUTION') && (
        <button onClick={() => sel && setPollution({ id: sel.id, name: sel.name })} disabled={!sel}
          style={btnDisabled(ui.btnItems, !!sel)}>شاخص شدت آلودگی</button>
      )}>
      {() => pollution && <CityContractorPollution city={pollution} onClose={() => setPollution(null)} />}
    </CrudView>
  );
}
